/**
 * Model that holds a dropdown item configuration.
 */
class DropdownItem {
    constructor() {
        /**
         * Specifies the events that trigger the dropdown item tooltip to appear. Multiple event names should be separated by spaces.
         */
        this._dropdownTooltipTrigger = 'manual';
    }
    get name() {
        return this._name;
    }
    setName(value) {
        this._name = value;
        return this;
    }
    get nameLabelKey() {
        return this._nameLabelKey;
    }
    setNameLabelKey(value) {
        this._nameLabelKey = value;
        return this;
    }
    get tooltip() {
        return this._tooltip;
    }
    setTooltip(value) {
        this._tooltip = value;
        return this;
    }
    get tooltipLabelKey() {
        return this._tooltipLabelKey;
    }
    setTooltipLabelKey(value) {
        this._tooltipLabelKey = value;
        return this;
    }
    get iconClass() {
        return this._iconClass;
    }
    setIconClass(value) {
        this._iconClass = value;
        return this;
    }
    get iconImage() {
        return this._iconImage;
    }
    setIconImage(value) {
        this._iconImage = value;
        return this;
    }
    get value() {
        return this._value;
    }
    setValue(value) {
        this._value = value;
        return this;
    }
    get dropdownTooltipTrigger() {
        return this._dropdownTooltipTrigger;
    }
    setDropdownTooltipTrigger(value) {
        this._dropdownTooltipTrigger = value;
        return this;
    }
    get cssClass() {
        return this._cssClass;
    }
    setCssClass(value) {
        this._cssClass = value;
        return this;
    }
    get guideSelector() {
        return this._guideSelector;
    }
    setGuideSelector(value) {
        this._guideSelector = value;
        return this;
    }
}

export { DropdownItem as D };
